import { Skeleton } from '@app/components/various/Skeleton';

export const CheckoutPaymentsSkeleton = () => {
  return (
    <div>
      <div className="mb-5 max-w-72">
        <Skeleton type="text" size="large" />
      </div>
      <div className="mb-5 space-y-2">
        <Skeleton type="rectangle" className="h-16 w-full" />
        <Skeleton type="rectangle" className="h-16 w-full" />
      </div>
      <div className="flex justify-between py-5">
        <dt className="basis-1/2">
          <Skeleton type="text" size="medium" />
        </dt>
        <dd className="basis-1/3">
          <Skeleton type="text" size="medium" />
        </dd>
      </div>
    </div>
  );
};
